<template lang="html">
  <div>
    <form @submit.prevent="login()" id="login-form">
      <div class="inner">
        <h1 class="text-center">Войти в систему</h1>
        <div v-bind:class="{ error: errors.username[0] }" class="form-group email">
          <label for="email">Имя пользователя</label>
          <input id="email" type="text" class="form-control" placeholder="Введите имя пользователя" v-model="username" autofocus>
          <div class="error">{{ errors.username[0] }}</div>
        </div>
        <div v-bind:class="{ error: errors.password[0] }" class="form-group password">
          <label for="password">Пароль</label>
          <input id="password" type="password" class="form-control" placeholder="Введите пароль" v-model="password">
          <div class="error">{{ errors.password[0] }}</div>
          <div v-show="false" class="text-right link-forgot-password">
            <router-link :to="{ name: 'reset-password'}">забыли пароль?</router-link>
          </div>
        </div>
        <div class="text-center">
          <input type="submit" class="btn btn-primary btn-lg" value="Войти">
        </div>
        <div class="text-center">
          <router-link :to="{ name: 'register'}">Нету аккаунта? Зарегистрируйтесь здесь</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auth from '../auth'
import helpers from '@/helpers'

export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',

      showError: false,

      errors: {
        username: [],
        password: [],
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,
    login () {
      auth.login(this.username, this.password).then((res) => {
        this.showError = !res.success

        if (res.success) {
          this.$router.push({ name: 'all-clients' })
        } else {
          this.fillErrors(this.errors, res.err.response.data)

          if (this.errors.non_field_errors[0]) {
            this.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?386bb932